import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';
import React from 'react';
import SentimentDot from './SentimentDot.jsx';

RatingLabel.defaultProps = {
  className: undefined,
  rating: null,
};

function RatingLabel({
  className,
  rating,
  reverse,
  isArchived = false,
  isShowIcon = true,
  isDelete = false,
  filled = false,
}) {
  if (!rating) return '—';

  const content = (
    <React.Fragment>
      {!isArchived && isShowIcon ? (
        <SentimentDot sentiment={rating} small reverse={reverse} />
      ) : null}
      <span
        className={classNames(
          'text-capitalize',
          className,
          isDelete && 'text-muted'
        )}
      >
        {rating.split('_').join(' ')}
      </span>
    </React.Fragment>
  );

  return filled ? (
    <span
      className={classNames(
        'rating-label-filled',
        `rating-label-filled-${kebabCase(reverse ? `-${rating}-reverse` : rating)}`
      )}
    >
      {content}
    </span>
  ) : (
    content
  );
}

export default RatingLabel;
